import { render, staticRenderFns } from "./DetailRow.vue?vue&type=template&id=f63ef7ba&"
import script from "./DetailRow.vue?vue&type=script&lang=ts&"
export * from "./DetailRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports